import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { SESSION_KEYS } from "../../common/constants/sessionKeys";
import styles from "./success.module.scss";

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const [fromLocation, setFromLocation] = useState<string | null>();
  const [toLocation, setToLocation] = useState<string | null>();
  const [journeyDate, setJourneyDate] = useState<string | undefined | null>();
  const [confirmationId, setConfirmationId] = useState<
    string | undefined | null
  >();

  useEffect(() => {
    setFromLocation(sessionStorage.getItem(SESSION_KEYS.FROM_LOCATION));
    setToLocation(sessionStorage.getItem(SESSION_KEYS.TO_LOCATION));
    setJourneyDate(searchParams.get("journeyDate"));
    setConfirmationId(searchParams.get("confirmationId"));
  }, [searchParams]);

  return (
    <main className="container">
      <div className={styles.successContainer}>
        <div className={styles.successIcon}>✓</div>
        <h1 className={styles.successTitle}>Booking Confirmed!</h1>
        <p className={styles.successSubtitle}>
          Your bus ticket has been booked successfully. Have a safe journey!
        </p>

        <div className={styles.detailsCard}>
          <div className={styles.detailsTitle}>Booking Details</div>
          <div className={styles.detailRow}>
            <span>Journey Date</span>
            <strong>{journeyDate}</strong>
          </div>
          <div className={styles.detailRow}>
            <span>From</span>
            <strong>{fromLocation}</strong>
          </div>
          <div className={styles.detailRow}>
            <span>To</span>
            <strong>{toLocation}</strong>
          </div>
          <div className={styles.detailRow}>
            <span>Reference ID</span>
          </div>
          <div className={styles.refId}>{confirmationId}</div>
        </div>

        <p className={styles.note}>
          Please carry a valid photo ID along with this reference ID for
          verification during travel.
        </p>
        <p className={styles.note}>
          You can also view and download your ticket from the{" "}
          <Link to="/my-tickets">My Tickets</Link> section.
        </p>

        <div className={styles.actions}>
          <Link to="/" className={`btn btn-outline-primary ${styles.homeBtn}`}>
            Back to Home
          </Link>
          <Link
            to="/my-tickets"
            className={`btn btn-primary ${styles.ticketsBtn}`}
          >
            View My Tickets
          </Link>
        </div>
      </div>
    </main>
  );
};

export default SuccessPage;
